import { UseMutationOptions } from "@tanstack/react-query";
import { useMutationApi } from "api/hooks.ts";
import { userSettingApi } from "api/TenantSlug/UserSetting/api.ts";
import { AxiosError } from "axios";
import { ApiErrorResponse } from "types/models.ts";

import UpdateUserSettingsRequest = App.Http.Requests.UserSetting.UpdateUserSettingsRequest;
import GetUserSettingsResponse = App.Http.Responses.UserSetting.GetUserSettingsResponse;

export const useUpdateUserSettingsMutation = (
    userId: string,
    options: UseMutationOptions<
        GetUserSettingsResponse,
        AxiosError<ApiErrorResponse>,
        UpdateUserSettingsRequest
    > = {}
) => {
    return useMutationApi<GetUserSettingsResponse, UpdateUserSettingsRequest>({
        mutationKey: ["updateUserSettings", userId],
        mutationFn: (request) => userSettingApi.update(userId, request),
        ...options,
    });
};
